import React, { useState, useEffect } from "react";
import "./dashboard.css";
import Card from "../Card";
import Reports from "../Ventas/Reports";
import TopSelling from "../TopSelling";
//import RecentActivity from "../Recent/RecentActivity";
import Usuarios from "../Usuarios/Usuarios";
import Clientes from "../Clientes/Clientes";
import { useAuthStore } from "../../../../store/store";
//import { useShallow } from "zustand/react/shallow";
import { Sections } from "../../data/navItem";
import toast, { Toaster } from "react-hot-toast";
import Asociados from "../Asociados/Asociados";
//import AskForNotificationPermisionModal from "../AskForNotificationPermisionModal";
import ProductsContainer from "../Productos/ProductsContainer";
import MyFunctionalComponent from "../../helperFunctions/WebSocketTest";
import Cobranza from "../Cobranza/Cobranza";
import Notificaciones from "../Notificaciones/Notificaciones";
import Configuraciones from "../Configuraciones/Configuraciones";

function Dashboard() {
  const askForNotificationsPermisionsModal = React.useRef(null);

  const setNotificationCount = useAuthStore(
    (state) => state.setNotificationCount
  );

  const [cards, setCards] = useState([]);
  //const { status } = useAuthStore((state) => ({ status: state.status }));
  /*const { sectionId } = useAuthStore(
    useShallow((state) => state.status.sectionId)
  );*/

  const { sectionId, subSection } = useAuthStore((state) => state.status);
  //const permission = HasPermission(sectionId, ["ver"]);

  function registerOnMessage() {
    try {
    } catch (error) {
      console.log(error);
    }
    console.log("boomer");
  }

  const fetchData = () => {
    setCards([
      {
        _id: 1,
        name: "Ventas",
        icon: "bi bi-cart",
        amount: 145,
        percentage: 0.12,
        active: true,
      },
      {
        _id: 2,
        name: "Ganancias",
        icon: "bi bi-currency-dollar",
        amount: 3246,
        percentage: 0.08,
        active: false,
      },
      {
        _id: 3,
        name: "Clientes",
        icon: "bi bi-people",
        amount: 1244,
        percentage: -0.11,
        active: false,
      },
    ]);
  };

  useEffect(() => {
    fetchData();
    registerOnMessage();

    // declare the data fetching function
    const requestPermission = async () => {
      const permission = await Notification.requestPermission();
      return permission;
    };

    // call the function
    let permission = requestPermission()
      // make sure to catch any error
      .catch(console.error);

    console.log("  -> " + permission);

    if ("Notification" in window) {
      //API supported
      console.log("--NOTifications YESSS");

      askForNotificationsPermisionsModal.current?.toggleModal();
    }
    /*
    // Named function "getBooks"
    async function getBooks() {
      try {
        const decodedToken = await getUsername();
        const permissions = pagoniRolesDetalles(decodedToken.rolId);

        HasPermission(sectionId, ["ver"]);
      } catch (err) {
        console.log("Error occured when fetching books");
      }
    }
    // Call named function
    getBooks();*/
  }, []);

  const subSectionId = subSection?._id ?? null;

  function clearCallback(e) {
    //  toast.success(e.data);

    const info = JSON.parse(e.data);

    const event = info.event;
    if (event === "notifications") {
      const notificationCount = info.notificationCount;
      setNotificationCount(notificationCount);
      const text = info.text ?? "";

      toast(
        (t) => (
          <span>
            <b>{text}</b>
            <button onClick={() => toast.dismiss(t.id)}>Dismiss</button>
          </span>
        ),
        { position: "bottom-right" }
      );
    }
  }

  //const sharedData = "My shared data!";

  return (
    <section className="dashboard section">
      <Toaster position="top-center" reverseOrder={false}></Toaster>
      {/*<AskForNotificationPermisionModal
        ref={askForNotificationsPermisionsModal}
      />*/}

      <MyFunctionalComponent clearCallback={(item) => clearCallback(item)} />

      <div className="row whole">
        <div className="col-lg">
          <div className="row">
            {sectionId === Sections.Productos &&
              cards &&
              cards.length > 0 &&
              false &&
              cards.map((card) => <Card key={card._id} card={card} />)}
            <div className="col-12">
              {sectionId === Sections.Clientes && (
                <Clientes subSectionId={subSectionId} />
              )}
            </div>
            <div className="col-12">
              {sectionId === Sections.Usuarios && <Usuarios />}
            </div>
            <div className="col-12">
              {sectionId === Sections.Reports && <Reports />}
            </div>
            <div className="col-12">
              {sectionId === Sections.Productos && (
                <ProductsContainer subSectionId={subSectionId} />
              )}
            </div>
            <div className="col-12">
              {sectionId === Sections.TopSelling && <TopSelling />}
            </div>
            <div className="col-12">
              {sectionId === Sections.Asociados && (
                <Asociados subSectionId={subSectionId} />
              )}
            </div>
            <div className="col-12">
              {sectionId === Sections.Configuraciones && (
                <Configuraciones subSectionId={subSectionId} />
              )}
            </div>
            <div className="col-12">
              {sectionId === Sections.Ventas && (
                <Reports subSectionId={subSectionId} />
              )}
            </div>
            <div className="col-12">
              {sectionId === Sections.Cobranza && (
                <Cobranza subSectionId={subSectionId} />
              )}
            </div>

            <div className="col-12">
              {sectionId === Sections.Notificaciones && (
                <Notificaciones subSectionId={subSectionId} />
              )}
            </div>
          </div>
        </div>
        {/*<div className="col-lg-4">
          <RecentActivity />
        </div>*/}
      </div>
    </section>
  );
}

export default Dashboard;
